import { PayloadAction } from "@reduxjs/toolkit";

export function onDeviceChange(state: DeviceState, action: PayloadAction<{ matchesPc: boolean, matchesTablet: boolean, matchesPhone: boolean }>): void {
    state.matchesPc = action.payload.matchesPc;
    state.matchesTablet = action.payload.matchesTablet;
    state.matchesPhone = action.payload.matchesPhone;
}
export interface DeviceState {
    matchesPhone: boolean,
    matchesTablet: boolean,
    matchesPc: boolean
}

